import styled from 'styled-components';

interface Props {
  logoSize?: number;
}

const RequestHead = styled.section<Props>`
  text-align: center;
  margin: 82px 0 26px;

  & img {
    height: ${({ logoSize }) => logoSize}px;
  }
`;

export default RequestHead;
